<template>
  <footer class="py-4 bg-[#243665] text-white">
    <div class="container mx-auto flex flex-col items-center text-sm space-y-1">
      <div class="text-lg font-semibold">fit@fit.org.ar</div>
      <div class="text-xs">© 2026 QREventos.com</div>
    </div>
  </footer>
</template>


<script>
import VueScrollTo from 'vue-scrollto';

export default {
  name: 'FooterSection',
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },
}

</script>